import { useState, useEffect } from 'react'
import { StyledButton } from 'src/styles/Button'
import { H3, TextBody } from 'src/styles/Typography'
import axios from 'axios'
import styled from 'styled-components'
import { positions } from './Positions'

const isMissing = (value) => value == null || value === ''

const CareersFormPortal = ({ setClose, pos }) => {
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)
  const [error, setError] = useState(false)
  const [form, setForm] = useState({
    position: '',
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
  })
  const [closeState] = useState()

  const [file, setFile] = useState(null)

  useEffect(() => {
    if (pos) {
      setForm({ ...form, position: pos })
    }
  }, [form, pos])

  const submit = async () => {
    const text = `<h3>Submission from careers page</h3><p><strong>Position:</strong> ${form.position}</p><p><strong>First Name:</strong> ${form.first_name}</p><p><strong>Last Name:</strong> ${form.last_name}</p><p><strong>Phone:</strong> ${form.phone}</p>`

    const formData = new FormData()
    formData.append('file', file, file.name)
    formData.append('text', text)

    await axios({
      method: 'post',
      url: 'https://48ct1d2shj.execute-api.us-east-1.amazonaws.com/prod/v1/submit',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(() => {
        setSuccess(true)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const getAllNonFilledFields = () => {
    const fields = Object.keys(form)
    const missing = fields.filter((field) => isMissing(form[field]))
    return missing
  }

  const handleSetForm = ({ target: { name, value } }) => {
    setForm((form) => ({ ...form, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()

    setError(false)
    setSuccess(false)
    setLoading(true)

    const nonFilledFields = getAllNonFilledFields()
    if (nonFilledFields.length || !file) {
      setLoading(false)
      return setError('All fields are required')
    }

    submit()
  }
  return (
    <FormPortal>
      <JobOpeningsBttn onClick={() => setClose(true)}>Close</JobOpeningsBttn>
      <Container>
        <Inner>
          {!success && <H3>Apply Today!</H3>}
          <Form onSubmit={handleSubmit}>
            {success ? (
              <Parent>
                <H3>Success!</H3>
                <TextBody>
                  We will review your information and reach out with any additional
                  questions.
                </TextBody>
              </Parent>
            ) : (
              <>
                <label htmlFor="position">
                  <span>Your position</span>
                  <select
                    name="position"
                    id="position"
                    value={form.position}
                    onChange={handleSetForm}
                  >
                    <option disabled value="" />
                    {positions.map((x, index) => (
                      <option key={`${x}-${index}`} name="position" value={x}>
                        {x}
                      </option>
                    ))}
                  </select>
                </label>

                <label htmlFor="first_name">
                  <span>First Name</span>
                  <input
                    id="first_name"
                    type="text"
                    name="first_name"
                    onChange={handleSetForm}
                    value={form.first_name}
                  />
                </label>

                <label htmlFor="last_name">
                  <span>Last Name</span>
                  <input
                    id="last_name"
                    type="text"
                    name="last_name"
                    onChange={handleSetForm}
                    value={form.last_name}
                  />
                </label>

                <label htmlFor="email">
                  <span>Email</span>
                  <input
                    id="email"
                    type="text"
                    name="email"
                    onChange={handleSetForm}
                    value={form.email}
                  />
                </label>

                <label htmlFor="phone">
                  <span>Phone Number</span>
                  <input
                    id="phone"
                    type="text"
                    name="phone"
                    onChange={handleSetForm}
                    value={form.phone}
                  />
                </label>
                <label htmlFor="upload-resume">
                  <span>Upload Resume</span>
                  <input
                    id="upload-resume"
                    type="file"
                    onChange={(e) => setFile(e.target.files[0])}
                  />
                </label>
              </>
            )}
            {!success && (
              <RequiredInformation>* Required Information</RequiredInformation>
            )}
            {error && <Error>{error}</Error>}
            {/*<Button
              text={success ? 'Success!' : 'Apply'}
              type="submit"
              loading={loading}
              className={clsx(success && styles.success)}
              disabled={success}
            />*/}
            {!success && <JobOpeningsBttn>Apply</JobOpeningsBttn>}
            {!success && (
              <Legal>
                By clicking Apply I hereby consent to receive communication from
                PolicyScout, GuideToInsure, InsureaLife including email, SMS, and phone.
              </Legal>
            )}
          </Form>
        </Inner>
      </Container>
    </FormPortal>
  )
}

export default CareersFormPortal

const Parent = styled.div``

const JobOpeningsBttn = styled(StyledButton)`
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    max-width: 352px;
    width: 100%;
    margin: 0 auto;
  }
`

const FormPortal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 774px;
  width: 100%;
  background: white;
  z-index: 1000;
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.15);
  border: solid 6px #40d1ff;
  @media (max-width: 759px) {
    overflow-x: hidden;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    transform: unset;
`

const Container = styled.div`
  width: 100%;

  @media (max-width: 759px) {
    grid-template-columns: 100%;
  }
`

const Inner = styled.div`
  padding: 30px;
  box-shadow: -1px 0 0 0 #ededed;
  z-index: 2;
  width: 100%;

  h3 {
    font-size: 23px;
    font-weight: 800;
    color: #252525;
  }
`

const RequiredInformation = styled.div`
  font-size: 12px;
  color: #e7582c;
  margin: 1em 0;
`

const Error = styled.div`
  margin-bottom: 1em;
  text-align: center;
`

const Legal = styled.div`
  margin-top: 12px;
  font-size: 12px;
  line-height: 1.33;
  color: #adadad;
`

const Form = styled.form`
  label {
    display: flex;
    flex-direction: column;

    & + label {
      margin-top: 1.5rem;
    }
    span {
      font-size: 14px;
      font-weight: 600;
      color: #606060;
      margin-bottom: 8px;

      &:after {
        content: '*';
        color: #e7582c;
        padding-left: 5px;
      }
    }

    input,
    select {
      height: 36px;
      border: solid 1px #dcdcdc;
      background-color: #ffffff;
      width: 100%;
      padding: 0 13px;
      font-size: 16px;

      &:focus {
        outline: 1px solid lighten(#e7582c, 5%);
      }
    }

    input[type='file'] {
      color: black;
      cursor: pointer;
    }

    select {
      appearance: none;
      background-image: url('src/images/newLanding/select-arrows.svg');
      background-repeat: no-repeat;
      background-position-x: 85%;
      background-position-x: calc(100% - 0.75em);
      background-position-y: 50%;
    }
  }

  ${JobOpeningsBttn} {
    display: inline-block;
    height: 44px;
    width: 100%;
    font-size: 16px;
    min-height: auto;

    &.success {
      background: green;
      border: 2px solid green;
    }
  }
`
